import { trimSlash } from './trim.js'

export function getApiBaseUrl() {
  return trimSlash(import.meta.env.VITE_API_BASE_URL)
}

export function isApiUseRelative() {
  return import.meta.env.VITE_API_USE_RELATIVE === 'true'
}

export function isApiConfigured() {
  return getApiBaseUrl().length > 0 || isApiUseRelative()
}

export function isChatApiConfigured() {
  return isApiConfigured()
}

export function getMeetingNotesApiBaseUrl() {
  return trimSlash(
    import.meta.env.VITE_MEETING_NOTES_API_BASE_URL ||
      import.meta.env.VITE_AVATAR_API_BASE_URL ||
      'http://localhost:8010',
  )
}
